module.exports = __webpack_public_path__ + "static/media/index_footer_2.837bf2e0.png";